<template>
  <transition name="fade">
    <div class="popup" id="popup_thank_choosing_new" @click="$store.commit('cvDownload', false)">
      <div class="popup_block" @click.stop>
        <div class="close" @click="$store.commit('cvDownload', false)"></div>
        <div class="title_popup"  v-html="$store.getters.t('thanks_d')"></div>
        <div class="pos_relative">
          <ul>
            <li>
              <div class="icon" @click="printCv('pdf')">
                <img src="/vue/images/pdf_icon.png">
              </div>
            </li>
            <li>
              <div class="icon" @click="printCv('png')">
                <img src="/vue/images/jpg_icon.png">
              </div>
            </li>
          </ul>
        </div>
      </div>
    </div>
  </transition>
</template>
<script>
  import cvDownloadMix from "../../mixins/cvDownload";

  export default {
    props: {
      cv: {
        type: Number,
        required: true
      }
    },
    mixins: [
      cvDownloadMix
    ],
    methods: {
      printCv(format) {
          this.$store.commit('downloadType', format);
          this.$store.commit('cvDownloadId', this.cv);
          this.downloadCvMix(format);
      }
    }
  };
</script>



// WEBPACK FOOTER //
// resources/js/components/modals/cv-download.vue